import { render, staticRenderFns } from "./PersonDataItem.vue?vue&type=template&id=73166c66&scoped=true&"
import script from "./PersonDataItem.vue?vue&type=script&lang=js&"
export * from "./PersonDataItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73166c66",
  null
  
)

export default component.exports